import React, { createContext, useContext, useMemo, useState } from 'react';
import type { DiscountsContextType, Discount, DiscountRegistrationFunction } from './DiscountsProviderTypes';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

const DiscountsContext = createContext<DiscountsContextType | null>(null);

type ProviderProps = Readonly<{
  children: React.ReactNode;
}>;

export const DiscountsProvider = ({ children }: ProviderProps) => {
  const [discounts, setDiscounts] = useState<ReadonlyArray<Discount>>([]);

  const registerDiscount = useEventCallback<DiscountRegistrationFunction>(
    registration => {
      if (!discounts.some(existing => existing.code === registration.code)) {
        setDiscounts(prev => [...prev, registration]);
      }
    },
    [setDiscounts, discounts],
  );

  const value = useMemo(
    () => ({
      registerDiscount,
      discounts,
    }),
    [registerDiscount, discounts],
  );

  return <DiscountsContext.Provider value={value}>{children}</DiscountsContext.Provider>;
};

export const useDiscounts = (): DiscountsContextType | null => {
  const context = useContext(DiscountsContext);
  if (!context) {
    return null;
  }
  return context;
};
